import { HttpClient, HttpContext } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { CustomCategoryHierarchy } from '@catalog/const';
import { HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS, SITE_CONTEXT_CONFIG } from '@core/const';
import { OccEndpointsService, SiteContextConfig } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccCategoryDetailsService {
  constructor(
    private http: HttpClient,
    private occEndpoints: OccEndpointsService,
    @Optional() @Inject(SITE_CONTEXT_CONFIG) private contextConfig: SiteContextConfig,
  ) {}

  loadDetails(categoryId: string): Observable<CustomCategoryHierarchy> {
    const { catalogId, catalogVersionId } = this.contextConfig.context;

    const url = this.occEndpoints.buildUrl(OCC_ENDPOINTS.categoryDetails, {
      urlParams: { catalogId, catalogVersionId, categoryId },
      queryParams: { fields: 'seo,name,subcategories' },
    });

    return this.http.get<CustomCategoryHierarchy>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.categoryDetails),
    });
  }
}
